'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _waypoint = require('./waypoint.js');

var _waypoint2 = _interopRequireDefault(_waypoint);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Route = function () {
	function Route(map, settings) {
		(0, _classCallCheck3.default)(this, Route);

		this.waypoints = [];
		this.settings = settings;
		this.router = L.Routing.mapbox('pk.eyJ1IjoianNlYXJzMzEiLCJhIjoiY2o3bG5obHZqMmdvcDJxcW15bzFpdTB5NSJ9.lfom0YaF2Siy0-1T0y-EJw');

		for (var type in this.settings.pins) {
			var pin = this.settings.pins[type];
			var waypoint = new _waypoint2.default(map, pin);
			this.waypoints.push(waypoint);
		}
	}

	(0, _createClass3.default)(Route, [{
		key: 'createLayer',
		value: function createLayer() {
			var _this = this;

			if (this.settings.type === 'offroad') {
				var latlngs = _lodash2.default.map(this.waypoints, function (w) {
					return new L.latLng(w.latlng);
				});
				var line = L.polyline(latlngs, {
					color: this.settings.route_color
				});
				return _bluebird2.default.resolve(line);
			}

			var routeWaypoints = _lodash2.default.map(this.waypoints, function (w) {
				return new L.Routing.Waypoint(w.latlng);
			});
			return _bluebird2.default.promisify(this.router.route, { context: this.router })(routeWaypoints).then(function (routes) {
				if (typeof routes === 'undefined') {
					return null;
				}

				var line = new L.Routing.line(routes[0], {
					styles: [{
						color: _this.settings.route_color
					}]
				});
				return line;
			});
		}
	}]);
	return Route;
}();

exports.default = Route;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/route.js
// module id = 6
// module chunks = 0